import { render, staticRenderFns } from "./get-prize-dialog.vue?vue&type=template&id=d06b94a2&scoped=true&"
import script from "./get-prize-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./get-prize-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./get-prize-dialog.vue?vue&type=style&index=0&id=d06b94a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06b94a2",
  null
  
)

export default component.exports